<template>
     <div class="container">
         <div v-if="!menusData.blocksForm&&showVid" class="validate-box">
             <el-input
                size="small"
                class="input"
                placeholder="请输入密码"
                v-model="password"
                @keyup.enter.native.stop="handleVilidate"
             />
             <el-button
                 size="small"
                 type="primary"
                 plain
                 @click="handleVilidate"
             >确定</el-button>
         </div>
        <div v-else class="content">
            <contents
               v-loading="showLoading"
                class="share"
                :showType.sync="showType"
                :isPreview="true"
                :width.sync="width"
                :height.sync="height"
                :gameSceneProxy="gameSceneProxy"
                :version="version"
            />
        </div>
         <!--<Remark-->
            <!--:visible.sync="isVisible"-->
            <!--:data.sync="remarkData"-->
         <!--/>-->
    </div>
</template>

<script>
    import Config from '@/config/app'
    import contents from '../contents'
    // import Remark from '../menus/components/remark'
    import {getMessage} from "../../../../utils/messageEvent";
    // import * as MenusApi from '../../api/menusApi'
    import * as resultServer from '../../../../api/result'

    export default {
        name: "share",
        components: {
            contents,
            // Remark
        },
        created() {
            this.init()
            if(Config.domain !== 'yunkedun.com'){
                this.handleNoVilidate()
                this.version = this.$route.query.version
                this.gameSceneProxy = this.$route.query.gameSceneProxy               
            }else{
                this.showVid = true
            }
            // 监听cocos侧发过来的通知
            this.messageEvent()
        },
        mounted(){
            this.$nextTick(()=>{
                // 获取屏幕宽高
                let width = document.body.offsetWidth
                let height = document.body.offsetHeight

                // 判断当前宽高，哪个是16哪个是9
                let state = false
                if(width>height){
                    state = true
                }

                // 16:9
                if(state) {
                    const newHeight = width * 9 / 16
                    if (newHeight > height) {
                        width = 16 * height / 9
                    } else {
                        height = newHeight
                    }
                    this.width = width
                    this.height = height
                }
                // 9:16
                else if(state) {
                    const newWidth = height * 9 / 16
                    if (newWidth > width) {
                        height = 16 * width / 9
                    } else {
                        width = newWidth
                    }
                    this.width = width
                    this.height = height
                }
            })
        },
        watch: {
            '$store.state.menusData': {
                handler (vl) {
                    this.menusData = vl
                },
                deep: true,
                immediate:true
            }
        },
        data(){
            return {
                width: '100vw',
                height: '100vh',
                curType: '', // 当前课程类型
                password: '', // 密码
                isVisible: false, // 是否弹出备注
                showType: false, // 右边类型是否展开

                // 右击操作按钮
                optItem: null, // 操作右击的数据
                newMouseEnterItem: null, // 鼠标移到的数据元素
                optIsShow: false,
                optData: [{key: 'delete',value: '删除'}, {key: 'move',value: '移动'}, {key: 'copy',value: '复制'}],
                x: 0,
                y: 0,

                // 复制或移动
                isOptType: '', // 操作类型
                isOptToBlock: false,
                optToBlockItem: null,

                // 字体编辑位置
                isOperationFont: true,
                newLeft: 500,
                newTop: 300,

                // 菜单数据
                menusData: null,

                // 备注详情
                remarkData: [
                    // {
                    //     name: '板块1页面1',
                    //     content: `<p style="text-align: center">备注</p>`
                    // }
                ],
                cocosConfigAll: null,
                version:'',
                gameSceneProxy:'',
                showVid:false,
                showLoading: false
            }
        },
        methods: {
            getStatus(item){
                let state = false
                if (['game', 'tools'].includes(item.type)) {
                    const type = this.curType || this.$store.state.curClassType
                    switch (type) {
                        case 'online':
                            state = !item.config.is_online
                            if(`${item.config.is_online}` === `undefined`) state = false
                            break
                        case 'offline':
                            state = !item.config.is_offline
                            if(`${item.config.is_offline}` === `undefined`) state = false
                            break
                        case 'double_teacher':
                            state = !item.config.is_double_teacher
                            if(`${item.config.is_double_teacher}` === `undefined`) state = false
                            break
                    }
                }
                return state
            },
            // 校验密码
            async handleVilidate(){
                if(!this.password){
                    this.$message.error('请输入密码')
                    return false
                }

                const res = await resultServer.getShareContent({
                    id: this.$route.query.id,
                    password: this.password
                })

                // console.log('获取内容', res.data.attr_last.h5_remote)
                this.curType = res.data.type
                this.$store.state.menusData = res.data.attr_last.h5_remote
                sessionStorage.setItem('shareData', JSON.stringify(res.data))
            },
            // 不校验密码
            async handleNoVilidate(){
                this.showLoading = true
                const res = await resultServer.getShareContent({
                    id: this.$route.query.id,
                    password: '123456'
                })
                setTimeout(()=>{
                this.showLoading = false
                }, 1000)
                this.curType = res.data.type
                this.$store.state.menusData = res.data.attr_last.h5_remote
            },     
            // 整理成cocos配置
            getCocosConfig (data) {
                let newConfig = []
                try {
                    newConfig = data.blocksForm.map(v=>{
                        let lesson = []
                        // 判断菜单项是否有效
                        if(v.children && v.children.length>0) {
                            v.children.map(q => {
                                q.disabled = this.getStatus(q)
                            })
                            lesson = v.children
                            lesson = lesson.filter(v=>!v.disabled)
                        }
                        let obj = {
                            scene: v.name,
                            lesson
                        }
                        if(v.leaf && v.leaf.length>0){
                            obj.leaf = this.getNewLeaf({data:v.leaf})
                        }
                        return obj
                    })

                    // 将newConfig 转成 [{scene:xx, lesson: [], leaf: [{scene:xx, lesson: [], leaf: []}]}]
                    newConfig = this.loopFormat({data: newConfig})
                }catch (e) {
                    console.log('获取失败cocos所有配置==>', e)
                }
                return newConfig
            },
            getNewLeaf({data}){
                console.log('data==>', data, typeof data, Array.isArray(data), data.map)
                data.map(v=>{
                    let lesson = []
                    // 判断菜单项是否有效
                    if(v.children && v.children.length>0) {
                        v.children.map(q => {
                            q.disabled = this.getStatus(q)
                        })
                        lesson = v.children
                        lesson = lesson.filter(v=>!v.disabled)
                    }
                    v.lesson = lesson
                    v.scene = v.name
                    if(v.leaf && v.leaf.length>0){
                        v.leaf = this.getNewLeaf({data:v.leaf})
                    }
                })
                return data
            },
            // 将newConfig 转成 [{scene:xx, lesson: [], leaf: [{scene:xx, lesson: [], leaf: []}]}]
            loopFormat({data}){
                let obj = {}
                return data.map(v => {
                    obj = {
                        scene: v.scene,
                        lesson: v.lesson
                    }
                    if (v.leaf && v.leaf.length > 0) {
                        obj.leaf = this.getNewChilrens({data:v.leaf})
                    }
                    return obj
                })
            },
            // 监听cocos侧发过来的通知
            messageEvent(){
                getMessage((e)=>{
                    let type = ''
                    let {data} = e

                    // 模拟向cocos侧发出通知
                    if(data.type && data.type.substr(0,5)==='cocos'){
                        console.log('向cocos侧发出：'+data.type+'消息==>', e)
                    }

                    // cocos侧向web发出通知
                    if(data.type && data.type.substr(0,3)==='web'){
                        console.log('向web侧发出3：'+data.type+'消息==>', e)
                        type = data.type.substr(3)
                        switch (type) {
                            case 'GetConfig':
                                this.webGetConfig(data)
                                break;
                            case 'loadCompleted':
                            case 'loadCompletedH5':
                                this.webloadCompletedH5()
                                break;
                            default:
                        }
                    }
                })
            },
            webGetConfig(data){
                let value = this.getCocosConfig(this.menusData)
                console.warn('向cocos通知1==>', JSON.stringify({...data, type: 'GetConfig', value}))
                this.$toCocosMessage({...data, type: 'GetConfig', value})
            },
            webloadCompletedH5 () {
                this.$store.state.saving = false

                let fn = setTimeout( ()=> {
                    this.$store.state.initial = false
                    clearTimeout(fn)
                }, 800)
            },
            onRemark(item, index){
                console.log(item, index)
                if(!item){
                    // 列出当前列表的所有备注
                    let data = this.$utils.curSelectedNode({})
                    this.remarkData = data.children.map((v,i)=>{
                        return {
                            name: `${data.name}-${i+1}`,
                            content: v.remark?decodeURI(v.remark):'无'
                        }
                    })
                }else {
                    this.remarkData = [
                        {
                            name: '',
                            content: decodeURI(item.remark)
                        }
                    ]
                }
                this.isVisible = true
            },
            handleClose() {
                this.dialogVisible = false
                this.$emit('close')
            },
            async init(){
                // const res = await resultServer.getResultDetail({
                //     id: this.$route.query.id,
                //     clientsId: this.$route.query.school_id
                // })
                // this.menusData = res.data.attr_last.h5_remote
                // const shareData = JSON.parse(sessionStorage.getItem('shareData'))
                // if(shareData.type){
                // this.curType = shareData.type
                // this.$store.state.menusData = shareData.attr_last.h5_remote
                // }
            },
            remarck(data){
                console.log('备注==>', data)
            }
        }
    }
</script>
<style>
    html{min-width: auto !important;}
    .share.content-box .cocos_web{
        /*position: fixed;*/
        width: 100vw;
        height: 100vh !important;
        top: 0px;
        left: 0px;
    }
</style>
<style lang="scss" scoped>
.container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .content{
        .share{
            justify-content: center;
            align-items: center;
            width: 100vw;
            height: 100vh;
            position: fixed;
        }
    }

    .validate-box{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 100vh;

        background-color: #282828;
        background-image:
                -webkit-radial-gradient(black 15%, transparent 16%),
                -webkit-radial-gradient(black 15%, transparent 16%),
                -webkit-radial-gradient(rgba(255, 255, 255, 0.1) 15%, transparent 20%),
                -webkit-radial-gradient(rgba(255, 255, 255, 0.1) 15%, transparent 20%);
        background-image:
                radial-gradient(black 15%, transparent 16%),
                radial-gradient(black 15%, transparent 16%),
                radial-gradient(rgba(255, 255, 255, 0.1) 15%, transparent 20%),
                radial-gradient(rgba(255, 255, 255, 0.1) 15%, transparent 20%);
        background-position: 0 0px, 8px 8px, 0 1px, 8px 9px;
        background-size: 16px 16px;

        .input{
            width: 300px;
            margin-right: 10px;
        }
    }

    .content{
        display: flex;
        height: calc(100vh - 60px);
        flex-direction: row;
        justify-content: space-between;
    }
}
</style>
